export default (
	errorObj,
	customErrorMsg = "Something went wrong. Please reload page to continue"
) =>
	errorObj.response?.data?.errorList
		? errorObj.response?.data?.errorList[0].errorMessage
		: errorObj.response?.data?.messages
		? errorObj.response?.data?.messages[0]
		: errorObj.response?.data?.message ?? customErrorMsg;
